import _ from "lodash";
import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";
import { Table, UNKNOWN, CommonExportUtil as Util } from "./CommonExportUtil";
import { Project } from "../../dao/Project";
import { Member } from "../../dao/Member";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { F01Cache } from "../../dao/F01Cache";
import { F01CacheDAO } from "../../dao/F01CacheDAO";



export class F01_ExportManager {

  /**
   * 
   * @param is_save_cache 是否要在顯示時同時產保存 F01Cache 到資料庫
   * @param set_Progress 進度調顯示相關
   * @param common_form 
   * @param meta_table 
   * @param answer_list 
   * @param _Project 
   * @param sel_member_list 
   * @returns 
   */
  static async Export_F01v0(is_save_cache: boolean, set_Progress: ((value: React.SetStateAction<number>) => void) | null, 
    common_form: UniForm, meta_table: UiMetaTable, answer_list: UniAnswer[], _Project: Project, sel_member_list: Member[]): Promise<F01_ExportData[]> {
    
    let export_list: F01_ExportData[] = [];

    let total = answer_list.length;
    let ii = 0;

    for (const ans of answer_list) {
      ii++;

      let rhf_data = ans.ConvertToCommonRhfData();

      let export_data: F01_ExportData = new F01_ExportData();


      //#region 帶入基本資料
      let sel_ans_member = sel_member_list.find(member => member.guid === ans.member_guid); //取得該ans的member資料

      export_data.填寫日期 = Util.填寫日期(ans);

      export_data.項次 = Util.項次();

      export_data.廠區 = Util.廠區(_Project);
      export_data.部門代號 = Util.部門代號();
      export_data.部門名稱 = Util.部門名稱(sel_ans_member);

      export_data.工號 = Util.工號(sel_ans_member);//XXX 改以 member 為準 Util.GetString(rhf_data, "m01.基本資訊●工號●input_1");
      export_data.姓名 = Util.姓名(sel_ans_member);//XXX 改以 member 為準 Util.GetString(rhf_data, "m01.基本資訊●姓名●input_1");
      export_data.健檢日期 = Util.健檢日期(sel_ans_member);

      export_data.性別 = Util.性別(ans, sel_ans_member);
      //#endregion


      let 頻率RULE: Table = {
        "(1)總是": "1",
        "(2)常常": "2",
        "(3)有時候": "3",
        "(4)不常": "4",
        "(5)從未或幾乎從未": "5"
      }

      let 嚴重RULE: Table = {
        "(1)很嚴重": "1",
        "(2)嚴重": "2",
        "(3)有一些": "3",
        "(4)輕微": "4",
        "(5)非常輕微": "5"
      }

      export_data.Q1_1_你常覺得疲勞嗎 = Util.OptionValue(meta_table, rhf_data, "m02.個人_覺得疲勞", UNKNOWN, 頻率RULE);

      export_data.Q1_2_你常覺得身體上體力透支嗎 = Util.OptionValue(meta_table, rhf_data, "m02.個人_體力透支", UNKNOWN, 頻率RULE);

      export_data.Q1_3_你常覺得情緒上心力交瘁嗎 = Util.OptionValue(meta_table, rhf_data, "m02.個人_心力交瘁", UNKNOWN, 頻率RULE);
      export_data.Q1_4_你常會覺得我快要撐不下去了嗎 = Util.OptionValue(meta_table, rhf_data, "m02.個人_快要撐不下去", UNKNOWN, 頻率RULE);
      export_data.Q1_5_你常覺得精疲力竭嗎 = Util.OptionValue(meta_table, rhf_data, "m02.個人_精疲力竭", UNKNOWN, 頻率RULE);
      export_data.Q1_6_你常常覺得虛弱好像快要生病了嗎 = Util.OptionValue(meta_table, rhf_data, "m02.個人_覺得虛弱", UNKNOWN, 頻率RULE);

      export_data.Q2_1_你的工作會令人情緒上心力交瘁嗎 = Util.OptionValue(meta_table, rhf_data, "m03.工作_心力交瘁", UNKNOWN, 嚴重RULE);
      export_data.Q2_2_你的工作會讓你覺得快要累垮了嗎 = Util.OptionValue(meta_table, rhf_data, "m03.工作_快要累垮", UNKNOWN, 嚴重RULE);
      export_data.Q2_3_你的工作會讓你覺得挫折嗎 = Util.OptionValue(meta_table, rhf_data, "m03.工作_覺得挫折", UNKNOWN, 嚴重RULE);

      export_data.Q2_4_工作一整天之後你覺得精疲力竭嗎 = Util.OptionValue(meta_table, rhf_data, "m03.工作_精疲力竭", UNKNOWN, 頻率RULE);
      export_data.Q2_5_上班之前只要想到又要工作一整天你就覺得沒力嗎 = Util.OptionValue(meta_table, rhf_data, "m03.工作_不想上班", UNKNOWN, 頻率RULE);
      export_data.Q2_6_上班時你會覺得每一刻都很難熬嗎 = Util.OptionValue(meta_table, rhf_data, "m03.工作_覺得難熬", UNKNOWN, 頻率RULE);
      export_data.Q2_7_不工作的時候你有足夠的精力陪朋友或家人嗎 = Util.OptionValue(meta_table, rhf_data, "m03.工作_沒有精力陪伴", UNKNOWN, 頻率RULE);


      export_data.Q1_總分_個人疲勞 = 計算個人疲勞分數(export_data);
      export_data.Q1_個人疲勞分級 = 個人疲勞分級(export_data.Q1_總分_個人疲勞);

      export_data.Q2_總分_工作疲勞 = 計算工作疲勞分數(export_data);
      export_data.Q2_工作疲勞分級 = 工作疲勞分級(export_data.Q2_總分_工作疲勞);

      export_list.push(export_data);

    
      //#region 匯出時同時保存快取

      if (is_save_cache) {
        // 撈出舊資料
        let cache_data = await F01CacheDAO.FetchByMemberGuid(ans.member_guid);

        // 如果有則刪除
        if (cache_data != null) {
          await F01CacheDAO.Delete(cache_data);
        }

        // 重新新增
        cache_data = F01Cache.new_F01Cache(ans.member_guid, export_data);
        await F01CacheDAO.Insert(cache_data);
      }

      if (set_Progress != null) {
        const rate = (ii * 100.0 / total);
        set_Progress(rate);
      }

      //#endregion


    }

    return export_list;
  }

}


function 計算個人疲勞分數(export_data: F01_ExportData) {
  let score_rule: any = {
    "1": 100,
    "2": 75,
    "3": 50,
    "4": 25,
    "5": 0,
  }

  let score = 0;

  score += score_rule[export_data.Q1_1_你常覺得疲勞嗎];
  score += score_rule[export_data.Q1_2_你常覺得身體上體力透支嗎];
  score += score_rule[export_data.Q1_3_你常覺得情緒上心力交瘁嗎];
  score += score_rule[export_data.Q1_4_你常會覺得我快要撐不下去了嗎];
  score += score_rule[export_data.Q1_5_你常覺得精疲力竭嗎];
  score += score_rule[export_data.Q1_6_你常常覺得虛弱好像快要生病了嗎];
  const QUESTION_COUNT = 6;// 題目數量，用於平均

  score = score / QUESTION_COUNT;

  if (isNaN(score)) {
    return UNKNOWN;
  } else {
    return String(Math.round(score));
  }
}

function 個人疲勞分級(score: string) {
  let score_to_number_type = Number(score); // 轉成number型別

  if (isNaN(score_to_number_type)) {
    return UNKNOWN;
  } else if (score_to_number_type >= 0 && score_to_number_type < 50) {
    return "輕微";
  } else if (score_to_number_type >= 50 && score_to_number_type <= 70) {
    return "中度";
  } else if (score_to_number_type > 70 && score_to_number_type <= 100) {
    return "嚴重";
  } else {
    throw new_ErrorAlert('154389 個人疲勞分級 score 不在範圍內 score=' + score + ", score_to_number_type=" + score_to_number_type);
  }
}

function 計算工作疲勞分數(export_data: F01_ExportData) {
  let score_rule: any = {
    "1": 100,
    "2": 75,
    "3": 50,
    "4": 25,
    "5": 0,
  }

  let reverse_score_rule: any = {
    "1": 0,
    "2": 25,
    "3": 50,
    "4": 75,
    "5": 100,
  }

  let score = 0;

  score += score_rule[export_data.Q2_1_你的工作會令人情緒上心力交瘁嗎];
  score += score_rule[export_data.Q2_2_你的工作會讓你覺得快要累垮了嗎];
  score += score_rule[export_data.Q2_3_你的工作會讓你覺得挫折嗎];
  score += score_rule[export_data.Q2_4_工作一整天之後你覺得精疲力竭嗎];
  score += score_rule[export_data.Q2_5_上班之前只要想到又要工作一整天你就覺得沒力嗎];
  score += score_rule[export_data.Q2_6_上班時你會覺得每一刻都很難熬嗎];
  score += reverse_score_rule[export_data.Q2_7_不工作的時候你有足夠的精力陪朋友或家人嗎];// 注意此題分數算法相反
  const QUESTION_COUNT = 7;// 題目數量，用於平均

  score = score / QUESTION_COUNT;

  if (isNaN(score)) {
    return UNKNOWN;
  } else {
    return String(Math.round(score));
  }

}

function 工作疲勞分級(score: string) {
  let score_to_number_type = Number(score); // 轉成number型別

  if (isNaN(score_to_number_type)) {
    return UNKNOWN;
  } else if (score_to_number_type >= 0 && score_to_number_type < 45) {
    return "輕微";
  } else if (score_to_number_type >= 45 && score_to_number_type <= 60) {
    return "中度";
  } else if (score_to_number_type > 60 && score_to_number_type <= 100) {
    return "嚴重";
  } else {
    throw new_ErrorAlert('456565 工作疲勞分級 score 不在範圍內 score=' + score + ", score_to_number_type=" + score_to_number_type);
  }
}


export class F01_ExportData {
  填寫日期 = "";

  項次 = "";

  廠區 = "";
  部門代號 = "";
  部門名稱 = "";

  工號 = "";
  姓名 = "";
  健檢日期 = "";

  性別 = "";

  /* (一)個人	*/
  Q1_1_你常覺得疲勞嗎 = "";// 1.1
  Q1_2_你常覺得身體上體力透支嗎 = "";// 1.2
  Q1_3_你常覺得情緒上心力交瘁嗎 = "";// 1.3
  Q1_4_你常會覺得我快要撐不下去了嗎 = "";// 1.4
  Q1_5_你常覺得精疲力竭嗎 = "";// 1.5
  Q1_6_你常常覺得虛弱好像快要生病了嗎 = "";// 1.6

  /* (二)工作 */
  Q2_1_你的工作會令人情緒上心力交瘁嗎 = "";// 2.1
  Q2_2_你的工作會讓你覺得快要累垮了嗎 = "";// 2.2
  Q2_3_你的工作會讓你覺得挫折嗎 = "";// 2.3
  Q2_4_工作一整天之後你覺得精疲力竭嗎 = "";// 2.4
  Q2_5_上班之前只要想到又要工作一整天你就覺得沒力嗎 = "";// 2.5
  Q2_6_上班時你會覺得每一刻都很難熬嗎 = "";// 2.6
  Q2_7_不工作的時候你有足夠的精力陪朋友或家人嗎 = "";// 2.7

  Q1_總分_個人疲勞 = "";
  Q1_個人疲勞分級 = "";

  Q2_總分_工作疲勞 = "";
  Q2_工作疲勞分級 = "";

}

